import {
  CompositionEffect,
  EASING_BEZIER_IN_CUBIC,
  EASING_BEZIER_OUT_CUBIC
} from './CompositionEffect';
import { PropertyType } from '@beatflyer/shaders-lib';

const curveIn = EASING_BEZIER_OUT_CUBIC;
const curveOut = EASING_BEZIER_IN_CUBIC;

class Composition extends CompositionEffect {
  static id = 'composition-spin';
  static label = 'Spin';

  protected compose(position: number) {
    const { sprite } = this.layer;
    const p = curveIn(position);
    const scale = this.getProperty('scale') as number;
    const rotation = this.getProperty('rotation') as number;
    sprite.compositionTransform.rotation = ((1 - p) * rotation * Math.PI) / 180;
    sprite.compositionTransform.scale.set(1 - (1 - scale) * (1 - p));
    sprite.alpha = p;
  }

  protected decompose(position: number) {
    const { sprite } = this.layer;
    const p = curveOut(position);
    const scale = this.getProperty('scale') as number;
    const rotation = this.getProperty('rotation') as number;
    sprite.compositionTransform.rotation = (p * rotation * Math.PI) / 180;
    sprite.compositionTransform.scale.set(1 - (1 - scale) * p);
    sprite.alpha = 1 - p;
  }

  getPropertiesDescriptors() {
    const parentDescriptors = super.getPropertiesDescriptors();
    return {
      ...parentDescriptors,
      scale: {
        type: PropertyType.NUMBER,
        initialValue: 0.5
      },
      rotation: {
        type: PropertyType.NUMBER,
        minValue: 0,
        maxValue: 720,
        initialValue: 360
      }
    };
  }
}

(window as any).BeatFlyer.compositions[Composition.id] = Composition;



// WEBPACK FOOTER //
// ./src/compose/ComposeSpin.ts